import React, { useEffect } from "react";
import I18n from 'i18n.js.erb'


// Motivi restituiti da SubmissionList#withdrawal_unavailability_reason di cui al cliente viene
// detto il perché. Gli altri, come l'ordine passato da un aggregatore, restano senza spiegazione:
// chi vuole saperne di più trova la regola nei termini e condizioni, linkati dalla modale
const EXPLAINED_UNAVAILABILITY_REASONS = ['already_requested', 'already_handled', 'not_confirmed', 'processing_started', 'order_closed', 'window_expired'];

const GENERIC_REASON = 'generic';


const SubmissionListWithdrawalUnavailableModal = ({ show, reason, onClose }) => {

  useEffect(() => {
    if (!show) return;

    const onKeyDown = (event) => { if (event.key === 'Escape') onClose() };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [show, onClose]);

  if (!show) return null;

  const safeReason = EXPLAINED_UNAVAILABILITY_REASONS.includes(reason) ? reason : GENERIC_REASON;
  const termsUrl = `/${I18n.locale}/grading_service_terms_of_use.html#withdrawal`;

  return (
    <div className="slx-modal" onClick={onClose}>
      {/* il click sul contenuto non deve chiudere la modale, solo quello sullo sfondo */}
      <div className="slx-modal__dialog" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <div className="slx-modal__header">
          <h5 className="slx-modal__title">
            {I18n.t('js.editSubmissionListPage.withdrawal.unavailableModal.title')}
          </h5>
          <button type="button" className="slx-modal__close" aria-label="close" onClick={onClose}>x</button>
        </div>

        <div className="slx-modal__body">
          <p className="slx-withdrawal__paragraph">
            {I18n.t(`js.editSubmissionListPage.withdrawal.unavailableModal.reasons.${safeReason}`)}
            <br />
            {I18n.t('js.editSubmissionListPage.withdrawal.unavailableModal.termsIntro')}
            &nbsp;
            <a href={termsUrl} target="_blank" className="slx-link">
              {I18n.t('js.editSubmissionListPage.withdrawal.unavailableModal.termsLink')}
            </a>.
          </p>
        </div>

        <div className="slx-modal__footer">
          <button type="button" className="slx-pill" onClick={onClose}>
            {I18n.t('js.editSubmissionListPage.withdrawal.unavailableModal.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionListWithdrawalUnavailableModal;
